import React from 'react';
import enhance from './InfluencerProfile.enhancer';
import { Grid } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import InfluencerProfile from './InfluencerProfile';
import DealForm from '../../deals/new-deal/DealForm';
const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

class InfluencerProfileContainer extends React.Component {
  constructor() {
    super();
    const initialState = {
      step: 0,
      userId: ''
    };

    this.state = {
      ...initialState
    };
  }

  handleBackToListClick() {
    this.setState({
      step: 0
    });
  }

  handleProposeDealClick(campaignSelection) {
    this.setState({
      step: 1,
      campaign: campaignSelection
    });
  }

  handleBackClick() {}

  onProposalComplete() {
    this.setState({
      step: 0
    });
  }

  getStepContent(params) {
    const { key } = params;
    switch (this.state.step) {
      case 0:
        return (
          <InfluencerProfile
            userId={this.props.userId}
            navigateToDealProposal={this.handleProposeDealClick.bind(this)}
          />
        );
      case 1:
        return (
          <DealForm
            key={key}
            handleBackClick={this.handleBackClick.bind(this)}
            handleBackToListClick={this.handleBackToListClick.bind(this)}
            user={this.props.auth}
            onProposalComplete={this.onProposalComplete.bind(this)}
            dealRecipient={this.props.user}
            campaign={this.state.campaign}
          />
        );
    }
  }

  render() {
    const { step } = this.state;

    return (
      <VirtualizeSwipeableViews
        style={{ width: '100%' }}
        slideCount={2}
        index={step}
        slideRenderer={this.getStepContent.bind(this)}
        disabled={true}
      />
    );
  }
}

export default enhance(InfluencerProfileContainer);



// WEBPACK FOOTER //
// ./src/components/influencer/profile/InfluencerProfileContainer.js